import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const scrollWindowAndContainersToTop = () => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  document.querySelectorAll('.right-panel, .main-content, .pif-content-wrapper').forEach((el) => {
    if (el && typeof el.scrollTo === 'function') {
      el.scrollTo(0, 0);
    }
    if (el) {
      el.scrollTop = 0;
    }
  });
};

const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    scrollWindowAndContainersToTop();
    const raf = window.requestAnimationFrame(scrollWindowAndContainersToTop);
    return () => window.cancelAnimationFrame(raf);
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
